module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-47456e47.png";